module.exports = __webpack_public_path__ + "img/hotel.6773e111.png";